export default __webpack_public_path__ + "static/media/netflix_squid1.318d15a4.jpg";